export const LOGIN = 'auth@login';
export const REQUEST_LOGIN = 'auth@request-login';
export const FORGET_PASSWORD = 'auth@forget-password';
export const SET_AUTH_FORM_LOADING = 'auth@set-auth-form-loading';
export const SET_AUTH_DATA = 'auth@set-auth-data';
export const LOGOUT = 'auth@logout';
export const RESET_PASSWORD = 'auth@reset-password';
